module.exports = __webpack_public_path__ + "static/media/Leaf_Kids_square.e89ba47a.png";